import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=4e0080f3&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=4e0080f3&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e0080f3')) {
      api.createRecord('4e0080f3', component.options)
    } else {
      api.reload('4e0080f3', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=4e0080f3&", function () {
      api.rerender('4e0080f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/leaves/edit.vue"
export default component.exports